import { configureStore } from '@reduxjs/toolkit'
import mainReducer from './reducers/main'

export const store = configureStore({
  reducer: {
    main: mainReducer,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
       // Ignore these action types
       //ignoredActions: ["users/logIn/fulfilled"],
       // Ignore these field paths in all actions
       //ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
       ignoredActionPaths: ['payload.checkIn', 'payload.checkOut','action.payload.date'],
       // Ignore these paths in the state
       //ignoredPaths: ['items.dates'],
       ignoredPaths: ['main.checkIn','main.checkOut','main.minCheckIn','main.minCheckOut','main.maxCheckOut'],
     },
  }),
})

